const FilterIcon = () => {
  return (
    <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.22222 11.3332H9.77778V9.55539H6.22222V11.3332ZM0 0.666504V2.44428H16V0.666504H0ZM2.66667 6.88873H13.3333V5.11095H2.66667V6.88873Z" fill="#16161D" />
    </svg>
  )
}

export default FilterIcon;